import styled from "styled-components"

import Heading from "./Heading"

const H4 = styled.h4`
  ${Heading}

  font-size: 28px;
`

export default H4
